import { render } from "./AfterSale.vue?vue&type=template&id=6a22efba&scoped=true"
import script from "./AfterSale.vue?vue&type=script&lang=js"
export * from "./AfterSale.vue?vue&type=script&lang=js"

import "./AfterSale.vue?vue&type=style&index=0&id=6a22efba&scoped=true&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a22efba"]])

export default __exports__